export const iconFontAwesomeCampingPeopleRoof = (
	<i className="fa-solid fa-people-roof"></i>
);
